module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-07-dd586778a14b8d8e3f5e06f6650c9495.svg";